import React from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";

// Import assets (images + videos)
import icechestVideo from "../assets/icechestwater.jpg";
import solonetVideo from "../assets/solonet.mp4";
import timberImage from "../assets/timber.jpg";

const ventures = {
  "ice-chest-water": {
    title: "Ice Chest Water",
    type: "image",
    media: icechestVideo,
    description:
      "Ice Chest Water represents excellence in hydration combining purity, sustainability, and a refined sense of taste. At Ice Chest Water, we are committed to delivering safe, clean, and refreshing water straight to your home and business. With advanced purification and eco-friendly practices, we ensure every sip is pure.",
    website: "https://icechestmineralwater.com",
  },
  "solonet-properties": {
    title: "Solonet Properties",
    type: "video",
    media: solonetVideo,
    description:
      "Solonet Properties builds elegant, innovative, and smart homes that redefine modern luxury living. At Solonet Properties, we connect you with premium real estate solutions in Ghana. Our mission is to deliver luxury, comfort, and value through properties that redefine modern living.",
    website: "https://solonetproperties.com",
  },
  "global-timber-limited": {
    title: "Global Timber Limited",
    type: "image",
    media: timberImage,
    description:
      "Global Timber Limited sources and supplies the finest timber, offering sustainable products to construction and furniture industries worldwide.",
    website: "#",
  },
};

const VentureDetail = () => {
  const { slug } = useParams();
  const venture = ventures[slug];

  if (!venture)
    return (
      <div className="text-center text-white py-20">
        Business not found.
      </div>
    );

  return (
    <section className="bg-[#0a0a0a] text-white py-24 px-6 md:px-20 min-h-screen">
      <div className="max-w-5xl mx-auto">
        {/* Media (Video or Image) */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="rounded-2xl overflow-hidden shadow-lg mb-10"
        >
          {venture.type === "video" ? (
            <video
              src={venture.media}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-96 object-cover"
            />
          ) : (
            <img
              src={venture.media}
              alt={venture.title}
              className="w-full h-96 object-cover"
            />
          )}
        </motion.div>

        {/* Text Info */}
        <h1 className="text-4xl md:text-5xl font-playfair text-[#d4af37] mb-6">
          {venture.title}
        </h1>

        <p className="text-gray-300 text-lg leading-relaxed mb-10">
          {venture.description}
        </p>

        <a
          href={venture.website}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-yellow-400 text-black font-semibold px-6 py-3 rounded-full shadow-lg hover:bg-yellow-300 transition-transform transform hover:scale-105"
        >
          Visit Website
        </a>

        <br />
        <br />

        <Link
          to="/"
          className="text-yellow-400 hover:text-yellow-300 font-semibold mt-4 inline-block"
        >
          ← Back
        </Link>
      </div>
    </section>
  );
};

export default VentureDetail;
